<template>
  <MyManage>
    <el-tabs v-model="activeName" type="border-card" >
<!--      v-if="checkPermission(['bee:gunBox:gunBox:page'])"-->
      <template >
        <el-tab-pane label="箱变管理" name="gunBox">
          <GunBoxPage v-if="activeName=='gunBox'"></GunBoxPage>
        </el-tab-pane>
      </template>
    </el-tabs>
  </MyManage>
</template>
<!--import GunBox from './gunBox/gunBox.vue'-->
<script>

  import MyManage from '@/components/MyManage'
  import GunBoxPage from '@/module/resourceCenter/page/gunBox/gunBox.vue'

  export default {
    components: {
      MyManage,
      GunBoxPage,
    },
    data() {
      return {
        activeName: 'gunBox'
      }
    },
    created() {
    },
    mounted() {
    },
    watch: {},
    methods: {
    }
  }
</script>

<style type="less" scoped>
  /deep/ .el-switch.is-disabled .el-switch__core, /deep/ .el-switch.is-disabled .el-switch__label {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/gunBoxManage.vue